import React, { useState } from 'react';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { usePageTitle } from '../../../../App';
import datagain_home_page_hero_img from '../../../../assets/images/datagain-home-page-hero-img.png';
import logo from '../../../../assets/images/logo.svg';
import { LOGIN_ROUTE } from '../../../../constants/RouteNameConstants';
import { PASSWORD_INCLUDE_VALID, PASSWORD_MATCH_REQURIED } from '../../../../constants/ValidationMessageConstants';
import { newPasswordRequest } from '../actions';

function NewPassword() {
  usePageTitle('Datagain Transcription  - New Password'); // Set tab title

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const Id = searchParams.get('Id');
  const Token = searchParams.get('Token');

  // Regex pattern for password validation
  const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{6,}$/;

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    // Check if password meets the required pattern
    setPasswordValid(passwordPattern.test(value));

    // Check if passwords match
    if (confirmPassword !== '' && value !== confirmPassword) {
      setPasswordsMatch(false);
    } else {
      setPasswordsMatch(true);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    // Check if passwords match
    if (password !== value) {
      setPasswordsMatch(false);
    } else {
      setPasswordsMatch(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (passwordsMatch && passwordValid && password !== '' && confirmPassword !== '') {
      const params = {
        userId: Id,
        code: Token,
        password: password,
      };
      dispatch(newPasswordRequest(params));
    }
  };

  return (
    <div className="d-flex vh-100 w-100 flex-column overflow-y-auto bg-lighter">
      <div className="d-flex flex-grow-1 align-items-center justify-content-center py-4">
        <div className="login-card shadow-sm">
          <div className="form-group text-center mb-3">
            <div className="mb-3">
            <Link to={LOGIN_ROUTE}>
              <img src={logo} alt="logo" className="img-fluid logo-img" />
            </Link>
            </div>
            <div className="text-center">
              <h1 className="form-title text-center mb-0">Create New Password</h1>
              <p className="font-weight-normal opacity-50">
                Fill in your credentials and click on the New password button
              </p>
            </div>
          </div>

          <div>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md="12">
                  <label className="form-label fnt-14 fw-normal">Password</label>
                    <Form.Group className="mb-3 position-relative" controlId="exampleForm.ControlPassword">
                      <Form.Control
                        id="password"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Enter password"
                        value={password}
                        onChange={handlePasswordChange}
                        autoComplete="nope"
                        data-lpignore="true"
                      />
                      <div className="input-group-icon cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                      </div>
                      {!passwordValid && <Form.Text className="text-danger">{PASSWORD_INCLUDE_VALID}</Form.Text>}
                    </Form.Group>
                  </Col>
                  <Col md="12">
                  <label className="form-label fnt-14 fw-normal">Confirm Password</label>
                    <Form.Group className="mb-3 position-relative" controlId="exampleForm.ControlConfirmPassword">
                      <Form.Control
                        id="confirmPassword"
                        type={showConfirmPassword ? 'text' : 'password'}
                        placeholder="Enter confirm password"
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        autoComplete="nope"
                        data-lpignore="true"
                      />
                      <div
                        className="input-group-icon cursor-pointer"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      >
                        {showConfirmPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                      </div>
                      {!passwordsMatch && <Form.Text className="text-danger">{PASSWORD_MATCH_REQURIED}</Form.Text>}
                    </Form.Group>
                  </Col>
                </Row>
                <div className="d-grid gap-2 mt-2">
                  <Button
                    size="lg"
                    className="btn btn-primary"
                    type="submit"
                    disabled={!passwordValid || !passwordsMatch || !password || !confirmPassword}
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </div>
        </div>
      </div>
    </div>
  );
}

export default NewPassword;
